import React, { useState } from 'react';
import { Squad, User } from '../../../types';
import SessionsTab from './SessionsTab';
import FinancialsTab from './FinancialsTab';
import TeachersOverviewTab from './TeachersOverviewTab';
import RandomTab from './RandomTab';
import GrowthAnalyticsTab from './GrowthAnalyticsTab';

type Props = {
  squads: Squad[];
  students: User[];
};

const StatisticsTab: React.FC<Props> = ({ squads, students }) => {
  const [activeSubTab, setActiveSubTab] = useState<'growth' | 'sessions' | 'financials' | 'teachers' | 'random'>('growth');

  const subTabs = [
    { id: 'growth', label: 'Growth', icon: '📈' },
    { id: 'sessions', label: 'Sessions', icon: '📊' },
    { id: 'financials', label: 'Financials', icon: '💵' },
    { id: 'teachers', label: 'Teachers', icon: '👩‍🏫' },
    { id: 'random', label: 'Random', icon: '🎲' },
  ];

  return (
    <div>
      <div className="sub-nav">
        {subTabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id as any)}
            className={`tab-button ${activeSubTab === tab.id ? 'active' : ''}`}
          >
            <span className="tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>
      <div className="sub-nav-content">
        {activeSubTab === 'growth' && <GrowthAnalyticsTab squads={squads} students={students} />}
        {activeSubTab === 'sessions' && <SessionsTab />}
        {activeSubTab === 'financials' && <FinancialsTab squads={squads} />}
        {activeSubTab === 'teachers' && <TeachersOverviewTab />}
        {activeSubTab === 'random' && <RandomTab students={students} />}
      </div>
    </div>
  );
};

export default StatisticsTab;


